import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  input,
  output,
  TemplateRef,
} from '@angular/core';
import {
  NzContentComponent,
  NzLayoutComponent,
  NzSiderComponent,
} from 'ng-zorro-antd/layout';
import { HeaderComponent } from '../../atoms/header/header.component';
import { SiderComponent } from '../../atoms/sider/sider.component';
import { FooterComponent } from '../../atoms/footer/footer.component';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeaderComponent,
    SiderComponent,
    FooterComponent,
    NzContentComponent,
    NzLayoutComponent,
    NzSiderComponent,
    NzIconModule,
  ],
  selector: 'ui-layout-full-sider',
  template: `
    <nz-layout class="min-h-screen">
      <!-- Sider -->
      <nz-sider
        nzCollapsible
        [nzCollapsed]="isCollapsed()"
        [nzTrigger]="null"
        [nzCollapsedWidth]="75"
        [nzWidth]="192"
        class="fixed sm:block z-50"
      >
        <ui-sider [isCollapsed]="isCollapsed()" (onToggle)="toggle()">
          <ng-content sider-header select="[sider-header]"></ng-content>
          <ng-content sider-menu select="[sider-menu]"></ng-content>
          <ng-content sider-bottom select="[sider-bottom]"></ng-content>
        </ui-sider>
      </nz-sider>

      <!-- Main Layout -->
      <nz-layout
        class="duration-200 transition-all"
        [class.sm:pl-[75px]]="isCollapsed()"
        [class.sm:pl-48]="!isCollapsed()"
      >
        <!-- Header -->
        <ui-header class="fixed z-50 w-[-webkit-fill-available]">
          <ng-content select="[header]"></ng-content>
        </ui-header>

        <!-- Content -->
        <nz-content class="mt-10">
          <ng-content select="[content]"></ng-content>
        </nz-content>

        <!-- Footer -->
        @if (hasFooter) {
          <ui-footer>
            <ng-content select="[footer]"></ng-content>
          </ui-footer>
        }
      </nz-layout>
    </nz-layout>
  `,
})
export class LayoutFullSiderComponent {
  isCollapsed = input<boolean>();
  onToggle = output();

  @ContentChild('footer', { static: false }) footerContent?: TemplateRef<any>;

  toggle() {
    this.onToggle.emit();
  }

  get hasFooter(): boolean {
    return !!this.footerContent;
  }
}
